import React, { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

export interface RedirectToRootProps {
    loaded: boolean;
    children: React.ReactNode;
}

export const RedirectToRootRoute: React.FC<PropsWithChildren<RedirectToRootProps>> = ({ loaded, ...props }) => {
    return loaded ? <>{props.children}</> : <Navigate replace to={'/'} />;
};

